import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { reportsStoreFeatureName } from './consts';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsHttpClient } from './metrics/metrics.http-client';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';
import { ReportsVisualizationsEffects } from './visualizations/visualizations.effects';
import { ReportsVisualizationsHttpClient } from './visualizations/visualizations.http-client';
import {
  ReportsVisualizationsNamespace,
  ReportsVisualizationsReducer,
} from './visualizations/visualizations.store';

const reportsState = provideState(reportsStoreFeatureName, {
  [ReportsMetricsNamespace]: ReportsMetricsReducer,
  [ReportsVisualizationsNamespace]: ReportsVisualizationsReducer,
});

const reportsEffects = provideEffects([ReportsMetricsEffects, ReportsVisualizationsEffects]);

export const provideCoreReportsData = (): Array<EnvironmentProviders | Provider> => [
  ReportsMetricsHttpClient,
  ReportsVisualizationsHttpClient,
  reportsState,
  reportsEffects,
];
